import { Component, createRef } from 'react';
import { Subscription } from 'rxjs';

import { FileUpload } from '../../models/file-upload';
import { ConvertOption, ConvertOptionCategoy, DropdownOption } from '../../types/dropdown.type';
import { ReadableUtils } from '../../ui-utils/form-name-to-description.utils';
import { RxUtils } from '../../utils/rx-utils';
import { WindowUtils } from '../../utils/window.utils';
import { cloneDeep, isEqual } from '../../utils/lodash-min';
import styles from './convert-option.component.module.scss';
import { ConvertOptionsContext } from './convert-options-context';
import HTMLWidgetComponent from './html-widget/html-widget.component';
import { CategoryOptionSelections } from './html-widget/category-option-selections.component';


export interface ConvertOptionComponentProps {
    formGroup: ConvertOption;
    formCategory: ConvertOptionCategoy;
    fileUpload: FileUpload;
    convertOptionsContext: ConvertOptionsContext;
    selection: (data: any) => void;
}

interface ConvertOptionComponentState {
    selectedOption: DropdownOption;
    hidden: boolean;
}

/**
 * Should not emit the initial value as it can lead to infinit forceUpdate loop
 */
export default class ConvertOptionComponent extends Component<ConvertOptionComponentProps, ConvertOptionComponentState> {
    subscription: Subscription;
    c2pDropdown = createRef(); // Type should be C2PDropDownComponent
    htmlWidget = createRef(); // Type should be HTMLWidgetComponent

    get description() {
        return ReadableUtils.FormNameToDescriptionMap[this.props.formGroup.formGroupName] || undefined;
    }

    readonly state: Readonly<ConvertOptionComponentState> = this.getInitialStateFromPros(this.props);
    constructor(props: ConvertOptionComponentProps) {
        super(props);
        this.initialize();
    }

    initialize() {
        let selectedOption = this.props.formGroup.selections.find(s => s.selected);
        if (!selectedOption) {
            this.props.formGroup.selections[0].selected = true;
            selectedOption = this.props.formGroup.selections.find(s => s.selected);
        }

        this.props.selection({
            selection: selectedOption,
            group: this.props.formGroup,
        });
        this.props.convertOptionsContext.emitEvent({
            selection: selectedOption,
            group: this.props.formGroup,
        });
        // if (isPlatformBrowser(this.platformId)) {
        WindowUtils.dispatchResizeEvent(1000);
        // }

        this.subscription = this.props.convertOptionsContext.onSelectedOptionsChanged.subscribe({
            next: () => {
                const hidden = this.props.formGroup.hiddenFn &&
                    this.props.formGroup.hiddenFn(this.props.convertOptionsContext.getConvertOptionCategories() as any); // TODO Preact {} used to be this.optionsService.getOptionsFor(url)
                this.setState({
                    hidden: hidden,
                });
            }
        });
    }

    getInitialStateFromPros(props: ConvertOptionComponentProps) {
        let selectedOption = props.formGroup.selections.find(s => s.selected);
        if (!selectedOption) {
            props.formGroup.selections[0].selected = true;
            selectedOption = props.formGroup.selections.find(s => s.selected);
        }
        return {
            selectedOption: selectedOption,
            hidden: props.formGroup.hiddenFn &&
                props.formGroup.hiddenFn(props.convertOptionsContext.getConvertOptionCategories() as any),
        };
    }

    // TODO Preact subscribe to context and act on the changes
    // ngOnChanges(change: SimpleChanges) {
    //     if (change.formGroup.currentValue) {
    //         this.selectedOption = this.props.formGroup.selections.find(s => s.selected);
    //     }
    // }

    componentWillUnmount() {
        RxUtils.safeCloseSubscriber(this.subscription);
    }

    onOutputExtensionSelect(event) {
        let selectedOption = this.props.formGroup.selections.find(s => s.selected);
        if (!selectedOption) {
            this.props.formGroup.selections[0].selected = true;
            selectedOption = this.props.formGroup.selections.find(s => s.selected);
        }

        this.setState({
            selectedOption: selectedOption,
        })

        this.props.selection({
            selection: event,
            group: this.props.formGroup,
        });

        this.props.convertOptionsContext.emitEvent({
            selection: event,
            group: this.props.formGroup,
        });
    }

    getSelectedOption() {
        // if (this.c2pDropdown && !this.state.hidden) {
        //     const val = this.c2pDropdown.current.getFormItemData();
        //     if (this.htmlWidget) {
        //         val.formValue = this.htmlWidget.current.getFormItemResultArray();
        //     }
        //     return val;
        // }
        // return undefined;
        throw new Error('Not used. Removed on React migration');
    }

    clonedRenderedConvertOptions = null;
    shouldComponentUpdate(nextProps) {
        // This was commented out to improve INP
        // const shouldUpdate = !isEqual(this.clonedRenderedConvertOptions, nextProps.convertOptionsContext.getConvertOptionCategories());
        // this.clonedRenderedConvertOptions = cloneDeep(nextProps.convertOptionsContext.getConvertOptionCategories());
        return true;
    }

    render() {
        if (this.state.hidden) {
            return <span>Hidden</span>;
        }
        const categoryOption = this.props.formGroup;
        // TODO: Parent should be notify of the size of the child so that parent can hide the whole section
        // if (!categoryOption.selections || categoryOption.selections.length === 0) {
        //     return <span>Selection is empty</span>;
        // }
        // if (categoryOption.selections.length == 1) {
        //     if (!categoryOption.selections[0].formChildren) {
        //         return <span>Only one selection</span>;
        //     }
        // }

        if (categoryOption.selections.length < 10 || 1 == 1) {
            return <CategoryOptionSelections
                categoryOption={this.props.formGroup}
                categoryOptionSelections={this.props.formGroup.selections}
                convertOptionsContext={this.props.convertOptionsContext}
            ></CategoryOptionSelections>;
        }

        return (
            !this.state.hidden && <div>
                <div className={`${styles["convert-option"]}`}>
                    {
                        <HTMLWidgetComponent formGroup={this.props.formGroup}
                            convertOptionsContext={this.props.convertOptionsContext}
                            select={$event => this.onOutputExtensionSelect($event)}
                        ></HTMLWidgetComponent>
                    }
                </div>
                {
                    this.description && <small className={`alert alert-info ${styles.description}`} dangerouslySetInnerHTML={{ __html: this.description }}></small>
                }
                {
                    this.props.formGroup.note && <div className={`${styles["description"]} alert-sm ${this.props.formGroup.note.bsTextClass}`}>
                        {this.props.formGroup.note.text}</div>
                }
                {
                    this.state.selectedOption && <div >
                        {this.state.selectedOption.displayAs === 'parent' && <div>
                            {
                                // this.state.selectedOption.formChildren && <html-widget ref={this.htmlWidget} data={this.state.selectedOption.formChildren}
                                // fileUpload={fileUpload} select={($event) => this.onOutputExtensionSelect($event)}>
                                // </html-widget>
                            }
                        </div>}
                    </div>}
                {
                    this.state.selectedOption && this.state.selectedOption.note && <div className={`${this.state.selectedOption.note.bsTextClass} description`}>
                        {
                            this.state.selectedOption.note.textFormatter ?
                                this.state.selectedOption.note.textFormatter(this.state.selectedOption.note.text, this.state.selectedOption)
                                : this.state.selectedOption.note.text
                        }
                    </div>
                }
            </div>
        );
    }
}
